(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scheduled-task', {
                parent: 'entity',
                url: '/scheduled-task?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'eDocumentsApp.scheduledTask.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduled-task/scheduled-tasks.html',
                        controller: 'ScheduledTaskController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledTask');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scheduled-task-detail', {
                parent: 'scheduled-task',
                url: '/scheduled-task/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'eDocumentsApp.scheduledTask.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-detail.html',
                        controller: 'ScheduledTaskDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledTask');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduledTask', function($stateParams, ScheduledTask) {
                        return ScheduledTask.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'scheduled-task',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('scheduled-task-detail.edit', {
                parent: 'scheduled-task-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('scheduled-task.new', {
                parent: 'scheduled-task',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    executionDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('scheduled-task');
                    });
                }]
            })
            .state('scheduled-task.edit', {
                parent: 'scheduled-task',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('scheduled-task.delete', {
                parent: 'scheduled-task',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-delete-dialog.html',
                        controller: 'ScheduledTaskDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();
